// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OhMY","title":"styles_title__2lAcw"};